"use client"

import { useBlockchain } from "@/app/blockchains/use-blockchain"
import { PriceWrapper } from "@/app/price"
import { getBlockchainFromAddress } from "@anaconda/core/blockchain/address"
import type { NftSearchItem } from "@anaconda/core/nft/search/types"
import { useLingui } from "@lingui/react/macro"
import { CommandItem } from "@rarible_int/anaconda_ui_components"
import Image from "next/image"
import { memo } from "react"
import { PLACEHOLDER_IMAGE_SRC } from "../../item/view/item-media"

export const HeaderNftSearchItem = memo(function HeaderNftSearchItem({
  nft,
  onSelect,
  showBlockchain,
}: {
  nft: NftSearchItem
  onSelect: () => void
  showBlockchain: boolean
}) {
  const { t } = useLingui()
  const blockchain = getBlockchainFromAddress(nft.id)
  const { icon } = useBlockchain(blockchain)

  return (
    <CommandItem
      value={`${nft.name}_${nft.id}`}
      keywords={[nft.id]}
      onSelect={onSelect}
      className="flex h-14 cursor-pointer items-center gap-3 rounded px-3 hover:bg-accent"
      data-testid={`search-nft-item-${nft.id}`}
    >
      <div className="relative flex-none">
        <Image
          src={nft.image ?? PLACEHOLDER_IMAGE_SRC}
          alt={nft.name}
          width={32}
          height={32}
          className="h-8 w-8 rounded-sm object-contain"
          data-testid={`search-nft-item-image-${nft.id}`}
        />
        {showBlockchain && (
          <Image
            unoptimized
            className="absolute right-0 bottom-0 z-20 translate-x-1/2 translate-y-1/2 transform"
            src={icon}
            width={12}
            height={12}
            alt={t`Blockchain icon for ${blockchain}`}
          />
        )}
      </div>
      <span className="truncate text-foreground text-sm">{nft.name}</span>

      {nft.price && (
        <div className="ml-auto shrink-0">
          <PriceWrapper
            amount={nft.price.amount}
            currency={nft.price.currency}
            className="text-sm"
          />
        </div>
      )}
    </CommandItem>
  )
})
